import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {OccEndpointsService} from '@spartacus/core';
import {Observable} from 'rxjs';
import {AimoOAuthTokenResponse} from "./aimo-token-storage.service";


/**
 * OCC helper for server-side CDC token exchange
 */
@Injectable({
    providedIn: 'root',
})
export class AimoCdcTokenAdapter {
    constructor(
        protected http: HttpClient,
        protected occEndpoints: OccEndpointsService,
    ) {
    }

    exchange(code: string, user: string, lang: string): Observable<AimoOAuthTokenResponse> {
        return this.http.post<AimoOAuthTokenResponse>(this.occEndpoints.buildUrl('cdcToken'), {
            code,
            user,
            lang
        });
    }
}
